import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import MonthlyWeeklyRanking from './components/MonthlyWeeklyRanking';
import HistoricalRanking from './components/HistoricalRanking';
import KPIs from './components/KPIs';
import MainChart from './components/MainChart';
import AutorizacionesChart from './components/AutorizacionesChart'; // Import new component
import EfectorChart from './components/EfectorChart';
import ProductividadModal from './components/ProductividadSesiones';
import useChartData from './hooks/useChartData';

ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title, Tooltip, Legend, ChartDataLabels);

function App() {
  const {
    data,
    lastUpdated,
    selectedDate,
    handleDateChange,
    goToToday,
    colorFromString,
    indicatorsForSelectedDate,
    getMiniChartData,
    delegaciones,
    selectedDelegacion,
    setSelectedDelegacion,
    movimientos,
    selectedMovimiento,
    setSelectedMovimiento,
  } = useChartData();

  const mainIndicatorsData = data.filter(item => item.indicador !== 'Coincidencia de Efector');

  const [modalConfig, setModalConfig] = React.useState({ user: null, date: null, movimiento: null });

  const handleShowProductivity = (user, date = null) => {
    // La fecha viene en formato YYYY-MM-DD de la tarjeta, pero el selector usa YYYY-MM-DDTHH:mm:ss.sssZ. Normalizamos.
    const normalizedDate = date ? date.split('T')[0] : null;
    setModalConfig({ user, date: normalizedDate, movimiento: selectedMovimiento });
  };

  const handleCloseProductivity = () => {
    setModalConfig({ user: null, date: null, movimiento: null });
  };

  const exportToCSV = () => {
    const csvRows = [
      "fecha,usuario,cantidad", // CSV header
      ...data.map(item => {
              const date = new Date(item.fecha);
              const day = String(date.getUTCDate()).padStart(2, '0');
              const month = String(date.getUTCMonth() + 1).padStart(2, '0');
              const year = date.getUTCFullYear();
              const fecha = `${day}/${month}/${year}`;
              const usuario = item.indicador;        const cantidad = item.valor;
        return `${fecha},${usuario},${cantidad}`;
      })
    ];
  
    const csvContent = "data:text/csv;charset=utf-8," + csvRows.join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "precarga_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="App bg-light min-vh-100">
      <div className="container py-4 app-container">
        <header className="text-center mb-4">
          <div className="d-flex justify-content-center align-items-center mb-3">
            <h1 className="me-3">PRECARGA DE AUTORIZACIONES CON IA</h1>
            <button className="btn btn-primary" onClick={exportToCSV}>Exportar a CSV</button>
          </div>
        </header>
          
        <div className="sticky-header"> {/* New wrapper div with sticky-header class */}
          <div className="d-flex justify-content-center gap-4 mb-3 align-items-end flex-wrap">
            <div className="d-flex flex-column align-items-start">
              <label className="mb-1 fw-bold small">Seleccionar Fecha:</label>
              <div className="d-flex">
                <input 
                  type="date" 
                  className="form-control form-control-sm w-auto" 
                  value={selectedDate} 
                  onChange={handleDateChange} 
                />
                <button className="btn btn-secondary btn-sm ms-2" onClick={goToToday}>Hoy</button>
              </div>
            </div>

            <div className="d-flex flex-column align-items-start">
              <label className="mb-1 fw-bold small">Delegación:</label>
              <select 
                className="form-select form-select-sm w-auto" 
                value={selectedDelegacion} 
                onChange={(e) => setSelectedDelegacion(e.target.value)}
              >
                {delegaciones.map(d => (
                  <option key={d} value={d}>{d}</option>
                ))}
              </select>
            </div>

            <div className="d-flex flex-column align-items-start">
              <label className="mb-1 fw-bold small">Movimiento:</label>
              <div className="btn-group">
                {movimientos.map(m => (
                  <button
                    key={m}
                    className={`btn btn-sm ${selectedMovimiento === m ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => setSelectedMovimiento(m)}
                  >
                    {m}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <p className="text-muted small">Última actualización: {lastUpdated.toLocaleTimeString()}</p>
        </div>

        <KPIs
          indicatorsForSelectedDate={indicatorsForSelectedDate}
          selectedDate={selectedDate}
          colorFromString={colorFromString}
          getMiniChartData={getMiniChartData}
          onShowDetails={handleShowProductivity}
        />

        <MainChart data={mainIndicatorsData} title='Resultados de Precarga por Fecha' />
        <AutorizacionesChart
          selectedDelegacion={selectedDelegacion}
          selectedDate={selectedDate}
        /> {/* Render new component */}

        <EfectorChart selectedDelegacion={selectedDelegacion} />

        <HistoricalRanking data={mainIndicatorsData} onShowDetails={handleShowProductivity} />

        <MonthlyWeeklyRanking data={mainIndicatorsData} />

        {modalConfig.user && (
          <ProductividadModal 
            user={modalConfig.user}
            date={modalConfig.date}
            movimiento={modalConfig.movimiento}
            onClose={handleCloseProductivity}
            userColor={colorFromString(modalConfig.user)}
          />
        )}
      </div>
    </div>
  );
}

export default App;